export default {"src":"/_next/static/media/banner-vector-svg.2a702b29.svg","height":434,"width":971,"blurWidth":0,"blurHeight":0};